<template>
  <div class="campaigns login">
    <div class="inner-content">
      <h3 v-if="!failed">Проверяваме предоставения токън...</h3>

      <h3 v-else>Токънът е невалиден или изтекъл.<br>Моля опитайте се да влезете с потребителско име и парола <router-link :to="{ name: 'login' }">тук.</router-link></h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenLogin',

  data () {
    return {
      failed: false
    }
  },

  mounted () {
    this.$store.dispatch('login', {
      username: '',
      password: 'token:' + this.$route.params['token']
    }).then(() => {
      // success
      this.$store.commit('setLoading', false)

      // direct either to the provided base64 encoded URI or to the campaigns
      let redirect = this.$route.params['redirect']
        ? this.decodeURI(this.$route.params['redirect'])
        : '/кампании'

      this.$router.push(redirect)
    }).catch((error) => {
      console.log('failed', error)
      this.failed = true
      this.$store.commit('setLoading', false)
    })
  },

  methods: {
    decodeURI (uri) {
      return atob(decodeURI(uri))
    }
  }
}
</script>
